/*
 * @Author: your name
 * @Date: 2021-04-22 20:49:18
 * @LastEditTime: 2021-04-23 01:15:31
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \jhd-b2c-h5\src\store\modules\order.js
 */
import service from "../../service";
var state = {
  addrType: "",
  orderConLoading: false,
  orderConfirmData: {}
};
var mutations = {
  SET_ADDR_TYPE: function SET_ADDR_TYPE(state, type) {
    state.addrType = type;
  },
  SET_LOADING: function SET_LOADING(state, type) {
    state.orderConLoading = type;
  },
  SET_ORDER_CONFIRM: function SET_ORDER_CONFIRM(state, data) {
    state.orderConfirmData = data;
  }
};
var actions = {
  setAddrType: function setAddrType(_ref, type) {
    var commit = _ref.commit;
    commit("SET_ADDR_TYPE", type);
  },
  getOrderConfirm: function getOrderConfirm(_ref2, _ref3) {
    var commit = _ref2.commit;
    var callback = _ref3.callback,
        that = _ref3.that;
    var pintuanId = that.$route.query.pintuanId || "";
    var itemId = that.$route.query.itemId || "";
    return new Promise(function (resolve, reject) {
      service.getSettlementPage({
        "pintuanId": pintuanId,
        itemId: itemId
      }).then(function (res) {
        if (res.status === 200) {
          commit("SET_ORDER_CONFIRM", res.result);
        } else {
          if (!res.success) {
            that.$toast(res.message);
            setTimeout(function () {
              that.$router.back();
            }, 3000);
          }
        }

        callback && callback(true, res);
      }).catch(function (res) {
        // commit("GET_LIST",[])
        // commit("SET_BANNER",[])
        callback && callback(false, res);
      });
    });
  },
  // TODO:优惠券 换 新人直接购买 
  getNewerOrderConfirm: function getNewerOrderConfirm(_ref4, param) {
    var commit = _ref4.commit;
    Object.assign(param, {
      promotionType: 'newuser',
      pintuanId: ''
    });
    return new Promise(function (resolve, reject) {
      service.createOrderInfo(param).then(function (res) {
        if (res.status === 200) {
          commit("SET_ORDER_CONFIRM", res.result);
        }

        resolve(res);
      }).catch(function (err) {
        reject(err);
      });
    });
  },
  getCommonOrderConfirm: function getCommonOrderConfirm(_ref5, param) {
    var commit = _ref5.commit;
    return new Promise(function (resolve, reject) {
      service.getOrderInfo(param).then(function (res) {
        if (res.status === 200) {
          commit("SET_ORDER_CONFIRM", res.result);
        }

        resolve(res);
      }).catch(function (err) {
        reject(err);
      });
    });
  },
  setOrderConfirm: function setOrderConfirm(_ref6, info) {
    var commit = _ref6.commit;
    commit("SET_ORDER_CONFIRM", info);
  }
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};